export default __webpack_public_path__ + "static/type-it-dark-mode-70b8dd9d339e0db1678738f377d2b9cb.mp4";